import React, { Component } from 'react';
import { TenantService } from 'connection/TenantService';
import { getBuilderFlow, getFlowApplication, getTemplate } from 'services/CeberusApiService';
import { Card, List, Icon, Alert } from 'antd';
import { BaseRequest } from 'models/request/BaseRequest';
import { GridView } from 'models/GridView';
import { BuilderRequest } from 'models/request/BuilderRequest';
import { Tenant } from 'models/Blip/Tenant';
import { PushNotification } from 'utils/PushNotification';

const ListItem = List.Item;
const ListItemMeta = List.Item.Meta;

const BUILDER_PUBLISHED_FLOW_BUCKET_KEY = 'blip_portal:builder_published_flow';
const BUILDER_FLOW_BUCKET_KEY = 'blip_portal:builder_latestpublications:';
const BUILDER_FLOW_DATE = 'blip_portal:builder_latestpublications?$take=100';
const BLIP_DOMAIN = '@blip.ai';

export class Builder extends Component<BaseRequest> {

  tenantSelected: Tenant;

  state = {
    isLoading: true,
    resource: '',
    identifier: '',
    template: '',
    builderConfiguration: [],
    builderAllFlows: [],
  }

  async componentDidMount() {
    await this.loadPage();
  }

  loadPage = async () => {

    try {
      this.setState({ isLoading: true });
      this.tenantSelected = TenantService.getSelectedTenant();  
      const identifier = this.props.BotIdentifier.split('@')[0];

      var baseRquest = new BaseRequest();
      baseRquest.BotIdentifier = identifier;
      baseRquest.ClusterName = this.tenantSelected.name;

      const resource = await getBuilderFlow(new BuilderRequest(BUILDER_PUBLISHED_FLOW_BUCKET_KEY, this.tenantSelected.name, identifier, null));
      const template = await getTemplate(baseRquest);
      const builderConfiguration = await this.getConfigurationVariables(baseRquest);
      const flowsDate = await getBuilderFlow(new BuilderRequest(BUILDER_FLOW_DATE, this.tenantSelected.name, identifier, null));

      const builderAllFlows = await Promise.all(flowsDate.publications.map(async (flowGeneral: any) => {
        const builderFlow = await getBuilderFlow(new BuilderRequest(BUILDER_FLOW_BUCKET_KEY + flowGeneral.index, this.tenantSelected.name, identifier, null));
        return { flow: builderFlow.flow, date: flowGeneral.publishedAt, authorIdentity : flowGeneral.authorIdentity, index: flowGeneral.index };
      }))

      this.setState({
        resource,
        identifier,
        template,
        builderConfiguration,
        builderAllFlows
      });
      
      this.getItemList();
    } catch (error) {
      PushNotification.httpError(error);
    }finally{
      this.setState({ isLoading: false });
    }
  }

  getFlow = (flowEvent: any) : React.DetailedHTMLProps<React.HTMLAttributes<HTMLParagraphElement>, HTMLParagraphElement> => {
    const date = new Date(flowEvent.date).toLocaleString('pt-br');
    const flowAuthor = flowEvent.authorIdentity ? new String(flowEvent.authorIdentity).replace(BLIP_DOMAIN, '') : 'Unknow';
    return (
      <p key={flowEvent.date}>
        Published Date: {date}, Author Identity: {flowAuthor}
        <a
          href={this.buildFlowFile(flowEvent.flow)}
          className="ant-btn ml4 ant-btn-primary ant-btn-round ant-btn-sm"
          download={`${this.props.BotIdentifier}${date}.json`}
        >
          <Icon type="download" /> Download
        </a>
      </p>
    );
  };
  
  getItemList = () : Array<GridView> => {
    const builderConfiguration =
      this.state.builderConfiguration !== undefined
        ? Object.entries(
          this.state.builderConfiguration
        ).map(valuesflow => (
          <p key={valuesflow[0]}>
            <b>{valuesflow[0]} :</b> {valuesflow[1]}
          </p>
        ))
        : 'No registered variables'

    const latestFlowPublications = this.getAllFlowsExceptFirst();

    return [
      {
        title: 'Published Flow',
        invisible: this.state.template !== 'builder',
        description: this.state.resource != undefined
          ? <a
            href={this.buildFlowFile(this.state.builderAllFlows[0])}
            className="ant-btn ml4 ant-btn-primary ant-btn-round ant-btn-sm"
            download={`${this.state.identifier}.json`}><Icon type='download' /> Download</a>
          : 'Couldn\'t find the flow.'
      },
      {
        title: 'Latest Published Flows',
        invisible: this.state.template !== 'builder',
        description: latestFlowPublications
      },
      {
        title: 'Configuration Variables:',
        invisible: this.state.template !== 'builder',
        description: builderConfiguration,
      },
      {
        title: 'Alert:',
        invisible: this.state.template == 'builder',
        description: (
          <Alert
            message="Warning"
            description="This bot isn't a Builder"
            type="warning"
            showIcon
          />
        )
      }]
  }

  getAllFlowsExceptFirst = () : React.DetailedHTMLProps<React.HTMLAttributes<HTMLParagraphElement>, HTMLParagraphElement>[] | string => {
    return this.state.builderAllFlows !== undefined &&
      this.state.builderAllFlows.length > 1
      ? this.state.builderAllFlows.slice(1).map(flow => this.getFlow(flow))
      : "Couldn't find flows."
  }

  buildFlowFile = (buildFlow: any) : string => {
    try {
      return `data:text/json;charset=utf-8,${encodeURIComponent(JSON.stringify(buildFlow))}`;
    } catch (error) {
      return 'data:text/json;charset=utf-8,';
    }
  }

  getConfigurationVariables = async (baseResquest: BaseRequest) : Promise<string> => {
    try {
      const flow = await getFlowApplication(baseResquest)
      if (flow) {
        return flow.settings.flow.configuration || 'Undefined';
      }
      return 'Could not find the application flow';
    } catch (e) {
      return 'Something went wrong';
    }
  }

  render() {
    const itemList = this.getItemList()
    return (
      <div>
        <Card title="Builder">
          <List
            loading={this.state.isLoading || this.state.isLoading}
            itemLayout="horizontal"
            dataSource={itemList}
            renderItem={item =>
              !item.invisible ? (
                <ListItem>
                  <ListItemMeta
                    title={item.title}
                    description={item.description}
                  ></ListItemMeta>
                </ListItem>
              ) : (
                <></>
              )}
          ></List>
        </Card>
      </div>
    )
  }
}